class APIError extends Error {
  constructor(public override message: string, public response: any) {
    super(message);
  }
}
  
export default APIError;